"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommandMenu = void 0;
const react_1 = __importStar(require("react"));
const CommandMenuItems_1 = require("./components/CommanMenuItems/CommandMenuItems");
const getAdditionalContentNode_1 = require("./helpers/getAdditionalContentNode");
const Dropdown_1 = require("../controls/Dropdown");
const helpers_1 = require("../helpers");
const Menu_1 = require("../Menu");
const CommandMenuButton_1 = require("./components/CommandMenuButton/CommandMenuButton");
const useCommandMenu = (_a) => {
    var { ref, className, controlText, controlIcon, renderControl, items: menuItems, disabled, dropdownWidth, popoverConfig, controlTooltip, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["ref", "className", "controlText", "controlIcon", "renderControl", "items", "disabled", "dropdownWidth", "popoverConfig", "controlTooltip", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const rootRef = (0, react_1.useRef)(null);
    const buttonRef = ref || rootRef;
    const menuItemsRef = (0, react_1.useRef)([]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'command-menu-button', [initialDataSelectorId]);
    return (0, Dropdown_1.useDropdown)({
        ref: buttonRef,
        getAdditionalContentNode: () => (0, getAdditionalContentNode_1.getAdditionalContentNode)(menuItemsRef),
        onDidHide: () => {
            menuItemsRef.current = [];
        },
        renderControl: (renderControlProps) => {
            var _a;
            return (_a = renderControl === null || renderControl === void 0 ? void 0 : renderControl(renderControlProps)) !== null && _a !== void 0 ? _a : (react_1.default.createElement(CommandMenuButton_1.CommandMenuButton, Object.assign({}, rest, { ref: renderControlProps.button.ref, style: style, "data-selector-id": dataSelectorId, icon: controlIcon, isActive: renderControlProps.isActive, disabled: disabled, onClick: onClick, onMouseDown: (e) => {
                    renderControlProps.button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, tooltip: controlTooltip, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-CommandMenu', className) }), controlText));
        },
        renderPopover: ({ popover, content }) => {
            menuItemsRef.current = [popover.ref];
            return react_1.default.createElement(Menu_1.Menu, Object.assign({}, popover), content);
        },
        renderContent: (renderContentProps) => (react_1.default.createElement(CommandMenuItems_1.CommandMenuItems, { menuItems: menuItems, renderContentProps: renderContentProps, menuItemsRef: menuItemsRef })),
        dropdownWidth,
        popoverConfig
    });
};
exports.useCommandMenu = useCommandMenu;
//# sourceMappingURL=useCommandMenu.js.map